const styles = {
  accordion: {
    fontFamily: ({ theme }) => theme.fontFamily,
    width: "100%",
    borderTop: "6px solid #44BBA4",
    lineHeight: 1.6,
    boxShadow: "5px 5px 10px 0px #a4bac1",
  },
};

export default styles;
